import React from 'react';
import ReactDOM from 'react-dom';
import { App } from 'components/app';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

const baseUrl: string | null = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter
            key="browser-router"
            basename={baseUrl ?  baseUrl.replace(/\/+$/, '') : undefined} //remove trailing slash
        >
            <App/>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
